export class CartorioAllDTOModel {

    id : number;
    descricao : string;
    cidade : string;
    email : string;
    telefone : string;
    
}
